var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('navigation'),_c('page-cover'),_c('features'),_c('about-me'),_c('about-gestalt'),_c('services'),_c('collaboration'),_c('contact'),_c('page-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }